import eslocale from 'date-fns/locale/es';
import format from 'date-fns/format';
import add from 'date-fns/add';
import sub from 'date-fns/sub';
import diffYears from 'date-fns/differenceInYears';
import diffMonths from 'date-fns/differenceInMonths';
import diffWeeks from 'date-fns/differenceInWeeks';
import diffDays from 'date-fns/differenceInCalendarDays';

import diffHours from 'date-fns/differenceInHours';
import diffMinutes from 'date-fns/differenceInMinutes';
import diffSeconds from 'date-fns/differenceInSeconds';
import diffMilliseconds from 'date-fns/differenceInMilliseconds';
import isBefore from 'date-fns/isBefore';
import isWithinInterval from 'date-fns/isWithinInterval';

import {shortUnitDates, unitDates, unicodeTokens} from './unitDates';

const locales = {
  es: eslocale
}
// TODO add more supported locale

const getFunctionToDiffByMomentKey = momentKey => {
  switch(momentKey){
    case shortUnitDates.y:
    case unitDates.years:
      return diffYears;
    case shortUnitDates.M:
    case unitDates.months:
      return diffMonths;
    case shortUnitDates.w:
    case unitDates.weeks:
      return diffWeeks;
    case shortUnitDates.d:
    case unitDates.days:
      return diffDays;
    case shortUnitDates.h:
    case unitDates.hours:
      return diffHours;
    case shortUnitDates.m:
    case unitDates.minutes:
      return diffMinutes;
    case shortUnitDates.s:
    case unitDates.seconds:
      return diffSeconds;
    case shortUnitDates.ms:
    case unitDates.milliseconds:
      return diffMilliseconds
    default:
      return diffMilliseconds;
  }
}

const parseStringDate = (stringDate, format)=> {
  if(format ==='HH:mm'){
    const newD = new Date();
    const [ HH = 0, mm = 0] = stringDate.split(':');
    newD.setMinutes(mm);
    newD.setHours(HH);
    return newD;
  }
  if(stringDate.length>10 && !isNaN(Date.parse(stringDate))){
    return new Date(stringDate);
  }
  const [date, time] = stringDate.split(' ');
  let [ day, month, year] = date.split(/\/|-/);
  if(day.length === 4){
    [ day, year] = [ year, day];
  }
  day = parseInt(day);
  month = parseInt(month) -1;
  year= parseInt(year);
  let [ hours, minutes, seconds] = time.split(':');
  hours = parseInt(hours);
  minutes = parseInt(minutes);
  seconds= parseInt(seconds);
  return new Date(year, month, day, hours, minutes, seconds);
}

const parseMomentKeyToDateFnsKey = momentKey => {
  switch(momentKey){
    case shortUnitDates.y:
      return unitDates.years;
    case shortUnitDates.M:
      return unitDates.months;
    case shortUnitDates.w:
      return unitDates.weeks;
    case shortUnitDates.d:
      return unitDates.days;
    case shortUnitDates.h:
      return unitDates.hours;
    case shortUnitDates.m:
      return unitDates.minutes;
    case shortUnitDates.s:
      return unitDates.seconds;
    case shortUnitDates.ms:
      return unitDates.milliseconds;
    default:
      return momentKey;
  }
}

const adjustOffset = (d, offset ) => {
  const totalOffset = offset + d.getTimezoneOffset();
  return new Date( d.getTime() + ( totalOffset * 60 * 1000 ) );
}

const forceOffset = (d, offset) => {
  const totalOffset = offset * -1
  return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes() + totalOffset, d.getSeconds(), ));
}

const parseUnicodeTokens = stringTokens => {
  unicodeTokens.forEach(unicodeToken=>{
    if(stringTokens.indexOf(unicodeToken.moment)!==-1){
      stringTokens = stringTokens.replace(unicodeToken.moment, unicodeToken.datefns);
    }
  });
  return stringTokens;
}


export function Dates(...args) {
  if(args.length === 0){
    this._d  = new Date();
  }
  else{
    const [ _date, format = false ] = args;
    if(_date instanceof Dates){
      this._d  = _date._d
    }else if((typeof _date === 'object') && !(_date instanceof Dates)){
      const [{years = 0, months = 0, date = 0, hours = 0 , minute = 0, seconds = 0, milliseconds =0}] =  args;
      this._d = new Date();
      this._d.setYear(years);
      this._d.setMonth(months);
      this._d.setDate(date);
      this._d.setHours(hours);
      this._d.setMinutes(minute);
      this._d.setSeconds(seconds);
      this._d.setMilliseconds(milliseconds);
    }
    else {
      this._d = parseStringDate(_date, format);
    }
  }

  addMethod(this, "add", (a_number, unit_time) => {
    if(!isFinite(a_number)){
      return this;
    }
    // add number days to date, ej. add(2, 'hours')
    const keyToAdd = parseMomentKeyToDateFnsKey(unit_time);
    this._d = add(this._d, {
      [keyToAdd]: a_number
    });
    return this;
  });

  addMethod(this, "diff", (date_diff_object) => {
    let newM;
    if(date_diff_object instanceof Dates){
      newM = date_diff_object._d;
    }
    else if(date_diff_object instanceof Date){
      newM = date_diff_object;
    }
    else{
      newM = new Date(date_diff_object);
    }
    // get the difference in milliseconds
    const diffFn = getFunctionToDiffByMomentKey();
    return diffFn(this._d, newM);
  });

  addMethod(this, "diff", (date_diff_object, unit_time) => {
    let newM;
    if(date_diff_object instanceof Dates){
      newM = date_diff_object._d;
    }
    else if(date_diff_object instanceof Date){
      newM = date_diff_object;
    }
    else{
      newM = new Date(date_diff_object);
    }
    const diffFn = getFunctionToDiffByMomentKey(unit_time);
    return diffFn(this._d, newM);
  });

  addMethod(this, "diff", (date_diff_object, unit_time, noTruncate) => {
    let newM;
    if(date_diff_object instanceof Dates){
      newM = date_diff_object._d;
    }
    else if(date_diff_object instanceof Date){
      newM = date_diff_object;
    }
    else{
      newM = new Date(date_diff_object);
    }
    if(noTruncate){
      switch(unit_time){
        case 'days':
          const diffInMilliseconds = getFunctionToDiffByMomentKey()(this._d, newM);
          return (diffInMilliseconds/(86400*1000)).toFixed(2);
        default:
          throw new Error(`not support diff in ${unit_time}`)
      }
    }
    return getFunctionToDiffByMomentKey(unit_time)(this._d, newM);
  });

  addMethod(this, "subtract", (time, unit_time) => {
    const keyToAdd = parseMomentKeyToDateFnsKey(unit_time);
    this._d = sub(this._d, {
      [keyToAdd]: time
    });
    return this;
  });

  addMethod(this, "unix", () => {
    // return date in unix
    return Math.floor(this._d.getTime() / 1000);
  });

  addMethod(this, "unix", (unix_time) => {
    // get Date from unix
    this._d = new Date(unix_time * 1000);
    return this;
  });

  addMethod(this, "format", (format_date) => {
    try{
      // set format to date, ej. YYYY MM DD
      return format(this._d, parseUnicodeTokens(format_date), { locale: locales[ window.__localeId__ ]});
    }
    catch(e){
      console.error('[DATES] format error',e);
    }
  });

  addMethod(this, "toDate", () => {
    return this._d;
  });

  addMethod(this, "utcOffset", () => {
    return this._d.getTimezoneOffset();
  });

  addMethod(this, "utcOffset", (offset) => {
    this._d = adjustOffset(this._d, offset);
    return this;
  });

  addMethod(this, "utcOffset", (offset, flag) => {
    this._d = flag ? forceOffset(this._d, offset) : adjustOffset(this._d, offset);
    return this;
  });

  addMethod(this, "seconds", () => {
    return this._d.getSeconds();
  });

  addMethod(this, "second", (s) => {
    this._d.setSeconds(s);
    return this;
  });

  addMethod(this, "millisecond", (ms) => {
    this._d.setMilliseconds(ms);
    return this;
  });

  addMethod(this,"toString",() => {
    // "Thu Jul 09 2020 16:56:46 GMT-0500"
    return this._d.toString();
  });

  addMethod(this, "locale", (l) => {
    // this._d.locale(l); //TODO
    window.__localeId__= l;
    return this;
  });

  addMethod(this,"isValid",() => {
    return (this._d instanceof Date && !isNaN(this._d.valueOf()));
  });

  addMethod(this,"isBefore",(m) => {
    // m en la docuementación siempre debe de ser una instancia de Dates.
    let newM;
    if(m instanceof Dates){
      newM = m._d;
    }
    else{
      newM = m;
    }
    return isBefore(this._d,newM);
  });

  addMethod(this,"isBetween",(m1, m2) => {
    let newM1, newM2;
    if(m1 instanceof Dates){
      newM1 = m1._d;
    }
    else{
      newM1= new Date(m1);
    }

    if(m2 instanceof Dates){
      newM2 = m2._d;
    }
    else{
      newM2 = new Date(m2);
    }
    return isWithinInterval(this._d,{ start: newM1, end: newM2});
  });

  addMethod(this,"isSame",(m1, TypesDate) => {
    // m1 en la docuementación siempre debe de ser una instancia de Dates.
    let newM1;
    if(m1 instanceof Dates){
      newM1 = m1._d;
    }
    else{
      newM1= m1;
    }

    switch(TypesDate){
      case unitDates.days:
      case unitDates.day:
        return this._d.getDate() === newM1.getDate();
      case unitDates.months:
      case unitDates.month:
        return this._d.getMonth() === newM1.getMonth();
      case unitDates.years:
      case unitDates.year:
        return this._d.getFullYear() === newM1.getFullYear();
      default:
        throw new Error(`not support isSame in ${TypesDate}`)
    }
  });

  addMethod(this,"toObject",() => {
    return {
      date: this._d.getDate(),
      hours: this._d.getHours(),
      milliseconds: this._d.getMilliseconds(),
      minutes: this._d.getMinutes(),
      months: this._d.getMonth(),
      seconds: this._d.getSeconds(),
      years: this._d.getFullYear(),
    }
  });

  addMethod(this,"date",() => {
    // return day number
    return this._d.getDate();
  });

  addMethod(this,"month",() => {
    // return month number
    return this._d.getMonth();
  });

  addMethod(this,"day",() => {
    // return day number
    return this._d.getDate();
  });

  addMethod(this,"year",() => {
    // return year number
    return this._d.getFullYear();
  });

  addMethod(this,"minute", () => {
    return this._d.getMinutes();
  });

  addMethod(this,"hour", () => {
    return this._d.getHours();
  });

  addMethod(this,"minute",(minute) => {
    // set minutes in a date
    this._d.setMinutes(minute);
    return this;
  });

}

const addMethod = (object, name, fn) => {
  var old = object[name];
  object[name] = function () {
    if (fn.length === arguments.length) return fn.apply(this, arguments);
    else if (typeof old === "function") return old.apply(this, arguments);
  };
};



// WEBPACK FOOTER //
// ./src/packages/dates/lib/dates.js